<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">化学品领用审批</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item> -->
        <el-form-item label="申请单号">
          <el-input v-model="formInline.apply_no" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="申请人姓名">
          <el-input v-model="formInline.username" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="化学品名称">
          <el-input v-model="formInline.chemical_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择">
            <el-option v-for="item in $store.state.reviewStatus2" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请日期">
          <el-date-picker v-model="formInline.date" type="daterange" range-separator="至" value-format="yyyy-MM-dd"
            clearable start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column fixed prop="apply_no" label="申请单号" width="150">
        </custom-table-column>
        <custom-table-column fixed prop="chemical_name" label="化学品" min-width="150">
        </custom-table-column>
        <custom-table-column prop="quantity" label="领用数量" width="80">
        </custom-table-column>
        <custom-table-column prop="username" label="领用人" width="100">
        </custom-table-column>
        <custom-table-column prop="unit" label="单位" width="80">
        </custom-table-column>
        <custom-table-column prop="status_text" label="状态" width="80">
        </custom-table-column>
        <custom-table-column prop="apply_structure_1" label="所属院系" width="180">
        </custom-table-column>
        <custom-table-column prop="apply_structure_2" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="purpose" label="申请理由" min-width="200px">
        </custom-table-column>
        <custom-table-column prop="record_number" label="出库单号" width="140">
        </custom-table-column>
        <custom-table-column prop="review_name" label="审批人" width="100px">
        </custom-table-column>
        <custom-table-column prop="review_desc" label="说明原因" width="160px">
        </custom-table-column>
        <custom-table-column prop="review_time" label="审批时间" width="160px">
        </custom-table-column>
        <custom-table-column label="操作" fixed="right" width="130">
          <template slot-scope="scope">
            <!-- <el-button v-if="scope.row.status == 'apply'" @click="handleOper(scope.row.id, 'pass')" type="text"
              size="small">审批</el-button> -->
            <el-button @click="detailMethod(scope.row, 'view')" type="text" size="small">详情</el-button>
            <el-button v-if="scope.row.status == 1" @click="handleOper(scope.row, 2)" type="text"
              size="small">通过</el-button>
            <el-button v-if="scope.row.status == 1" @click="handleOper(scope.row, 3)" type="text"
              size="small">否决</el-button>
            <el-button v-if="scope.row.status == 2 && !scope.row.record_number" @click="handleEditChild(scope.row)"
              type="text" size="small">出库登记</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="采购详情" :visible.sync="detailDialogVisible" width="746px">
      <el-descriptions class="margin-top" title="申请单" direction="vertical" :column="3" border v-if="rowObj">
        <!-- <el-descriptions-item>
          <template slot="label">采购类别 </template> {{ rowObj.type }}
        </el-descriptions-item> -->
        <el-descriptions-item>
          <template slot="label">申请单号 </template> {{ rowObj.apply_no }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">化学品 </template> {{ rowObj.chemical_name }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">领用数量 </template> {{ rowObj.quantity }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">领用人 </template> {{ rowObj.username }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">单位 </template> {{ rowObj.unit }}
        </el-descriptions-item>
        <el-descriptions-item :span="2">
          <template slot="label">申请理由 </template> {{ rowObj.purpose }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">所属院系 </template> {{ rowObj.apply_structure_1 }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">专业 </template> {{ rowObj.apply_structure_2 }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">所属{{ $store.state.themeTitle }}室 </template> {{ rowObj.apply_training_room_name }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">状态 </template> {{ rowObj.status_text }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">说明原因 </template> {{ rowObj.review_desc }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">审批时间 </template> {{ rowObj.review_time }}
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <!-- <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <div style="padding: 8px 20px;">
        <el-tag v-if="formInline1.quantity">申请数量：{{ formInline1.quantity }}</el-tag>
      </div>
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
        <template v-if="ruleForm.status == 2">
          <div class="add_win">
            <div v-for="(item, index) in ruleForm.items" :key="index" class="add_win_body el-form">
              <el-form-item label="领用化学品" :prop="`items[${index}].chemical_item_id`">
                <el-select v-model="item.chemical_item_id" clearable filter placeholder="请选择" style="width:216px;"
                  @change="handleChemicalChange($event, item)">
                  <el-option v-for="(chem, index) in chemicals" :disabled="item.current_stock * 1 == 0" :key="index"
                    :label="chem.item_code" :value="chem.id">
                    <p>化学品编号：{{ chem.item_code }}</p>
                    <p v-if="chem.current_quantity" style=" color: #8492a6; font-size: 13px">当前库存：{{
                      chem.current_quantity }}</p>
                    <p v-if="chem.unit" style=" color: #8492a6; font-size: 13px">单位：{{ chem.unit }}</p>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发放数量" :prop="`items[${index}].quantity`">
                <el-input-number v-model="item.quantity" :precision="1" :step="0.1" :min="0"
                  :max="item.current_quantity ? item.current_quantity * 1 : 0" style="width:216px;"> </el-input-number>
              </el-form-item>
              <el-form-item label="单位" :prop="`items[${index}].unit`">
                <el-input v-model="item.unit" disabled placeholder="" style="width:216px;"></el-input>
              </el-form-item>
              <div class="add_win_del">
                <el-button type="danger" @click="handleItemDelete(item, index)" size="mini">删除</el-button>
              </div>
            </div>
            <div class="add_win_add">
              <el-button size="mini" @click="handleItemAdd()">新增一条+</el-button>
            </div>
          </div>
        </template>
        <el-form-item v-if="ruleForm.status == 3" label="说明原因" prop="review_desc"
          :rules="[{ required: true, message: '请输入', trigger: 'blur' }]">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.review_desc"
            style="width:336px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm', setStatus)">提交</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog> -->
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="510px">
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="说明原因" prop="approve_remark" :rules="isRefuse">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.approve_remark"
            style="width:336px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm', setStatus)">提交</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <ChemicalUseChild ref="digChild" :digVisible='visibleChildDialog' @closeDig="closeDig">
    </ChemicalUseChild>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import { mixinValidate } from '@/assets/js/mixin/validate';
import ChemicalUseChild from './component/chemicalUseChild.vue';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinOrgan, mixinFormatter, mixinValidate],
  data() {
    return {
      formInline: {
        apply_no: '',
        username: '',
        chemical_name: '',
        status: '',
        start_date: '',
        end_date: '',
        date: '',
      },
      formInline1: {
        quantity: '',
      },
      levell: [1, 2],
      detailDialogVisible: false,
      visibleChildDialog: false,
      rowObj: {},
      chemicals: [],
      curChems: [],
      rules: {
      },
      rulesRoot: {
        review_desc: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      ruleForm: {
        status: '',
        // review_desc: '',
        // items: [{ chemical_item_id: '', quantity: '', unit: '' }]
        id: '',
        approve_remark: ''
      },
    };
  },
  components: {
    ChemicalUseChild
  },
  computed: {
    isRefuse() {
      return this.ruleForm.status == 3 ? [{ required: true, message: '请输入', trigger: 'blur' }] : [];
    },
  },
  created() { },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // this.$store.dispatch('getTarinMent', { type: 'all' });
    // this.setRules()
  },
  methods: {
    // handleOper(row, status) {
    //   this.title = '通过';
    //   if (status == 3) {
    //     this.title = '否决';
    //     this.formInline1.quantity = ''
    //   } else {
    //     this.getChemicals(row.id)
    //     this.formInline1.quantity = row.quantity;
    //     this.ruleForm.items = [{ chemical_item_id: '', quantity: 0, unit: '', current_quantity: '' }]
    //   }
    //   this.centerDialogVisible = true;
    //   this.ruleForm.status = status;
    //   this.ruleForm.id = row.id;
    // },

    handleEditChild(row) {
      this.visibleChildDialog = true
      this.$refs.digChild.handleEditNew({
        "structure_1": row.apply_structure_1,
        "structure_2": row.apply_structure_2,
        "product_id": row.chemical_id,
        "quantity": row.quantity,
        "lyr": row.username,
        "training_room": row.apply_training_room_name,
        "training_room_id": row.apply_training_room_id,
        "usage": row.purpose,
        "date": row.created_at,
        "record_number": "",
        "apply_id": row.id,
      }, [])
    },
    closeDig(flag = false) {
      this.visibleChildDialog = false
      if (flag) {
        this.getList()
      }
    },
    handleOper(row, status) {
      this.title = status == 3 ? '否决' : '通过';
      this.centerDialogVisible = true;
      this.ruleForm.status = status;
      this.ruleForm.id = row.id;
    },
    handleChemicalChange(val, item) {
      const { unit, current_quantity } = this.$until.getLabelNameNew({ arr: this.chemicals, id: val })
      item.unit = unit;
      item.current_quantity = current_quantity;
      if (this.ruleForm.items.filter(item => item.chemical_item_id === val).length > 1) {
        this.$message({
          type: 'error',
          center: true,
          message: '该化学品已选择！',
        });
        item.chemical_item_id = '';
      }

      // this.curChems = this.chemicals.filter(item => !this.ruleForm.items.map(c => c.chemical_item_id).includes(item.id))
    },
    async setStatus() {
      let res = await this.$api.instance.interfaceServer(`api/chemical/borrow/approveApply`, 'post', this.ruleForm);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '处理成功！',
        });
        this.centerDialogVisible = false
        this.getList();
      }
    },
    setRules() {
      this.rules = {
        ...this.rulesRoot,
        ...this.generateArrRules()
      };
    },
    generateArrRules() {
      const arrRules = {};
      this.ruleForm.items.forEach((item, index) => {
        arrRules[`items[${index}].quantity`] = [
          { required: true, message: `请输入`, trigger: 'blur' },
          { validator: this.checkfloat, trigger: 'blur' }
        ];
        arrRules[`items[${index}].chemical_item_id`] = [
          { required: true, message: `请选择`, trigger: 'change' }
        ];
      });
      return arrRules;
    },
    handleItemDelete(item, index) {
      this.ruleForm.items.splice(index, 1);
    },

    handleItemAdd() {
      this.ruleForm.items.push({ chemical_item_id: '', quantity: '', unit: '', current_quantity: '' });
      this.setRules();

    },
    async getChemicals(id) {
      let res = await this.$api.instance.interfaceServer(`api/chemical/borrow/availableItems`, 'get', { id });
      if (res.code == 0 && res.data) {
        this.chemicals = res.data
        // this.curChems = this.$until.easyDeepCopy(this.chemicals)
      }
    },
    async handleClassChange(e) {
      if (this.ruleForm.training_room_id) {
        let params = { training_room_id: this.ruleForm.training_room_id };
        params.page = 1;
        params.size = 9999;
        let res = await this.$api.instance.interfaceServer('api/training/common/room/device/list', 'get', params);
        if (res.code == 0 && res.data) {
          this.eqs = res.data.data;
        }
      } else {
        this.eq = [];
      }
    },
    onSubmit() {
      console.log('submit!');
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    detailMethod(row, type = "view") {
      if (type == "view") {
        this.rowObj = row;
        this.detailDialogVisible = true;
      } else {
        this.handleEditNew(row, ['id'], () => {
          this.handleEditCallBackSetStruc({ major: 'apply_structure_2', dep: 'apply_structure_1', row: row })
        })
      }
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteDeviceScrap(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      params.items = params.items.map((item) => {
        return {
          type: item.type,
          name: item.name,
          num: item.num,
          id: item.id,
        };
      });
      params.items = JSON.stringify(params.items);
      let res = await this.$api.instance.interfaceServer('api/open_reservation/apply/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      if (params.date && params.date.length > 0) {
        params.start_date = params.date[0];
        params.end_date = params.date[1];
        delete params.date;
      }
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/chemical/borrow/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.beforeQueryByKey("structure_1", "structure_2")
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    resetForm(formName) {
      this.ruleForm.device_price = 0;
      this.remainder_quantity = 0;
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

.el-select-dropdown__item {
  height: auto !important;
  line-height: 20px;
  padding: 4px 30px;
}
</style>
